import * as React from 'react';
import { FC } from 'react';
import useLocalised from 'customHooks/useLocalised/useLocalised';
import styles from './Benefits.module.scss';
import { Body, Small } from 'components/text';
import BenefitTickIcon from 'components/icons/BenefitTickIcon';
import { benefits_title } from 'data/translationKeys';
import useMediaQuery from '@mui/material/useMediaQuery';

interface IBenefitsItem {
  benefits: string[];
  benefitsFootnotes: string[];
}

const Benefits: FC<IBenefitsItem> = ({ benefits, benefitsFootnotes }) => {
  const benefits_title_text = useLocalised(benefits_title);
  const isMobile = useMediaQuery(`(max-width:700px)`);

  return (
    <div>
      {benefits.length > 0 && (
        <div className={styles.benefitsContainer}>
          <Body weight="demiBold" color="black">
            {benefits_title_text}
          </Body>
          {benefits.map((benefit, index) => (
            <div key={index} className={styles.benefitsRow}>
              <BenefitTickIcon />
              <Body color="black">{benefit}</Body>
            </div>
          ))}
          {benefitsFootnotes.length > 0 &&
            !isMobile &&
            benefitsFootnotes.map((footNote, index) => (
              <div key={index} className={styles.footNotesRow}>
                <Small xs color="grey-dark">
                  {footNote}
                </Small>
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export default Benefits;
